import React, { useState } from "react";
import a from "../../assets/images/whiteBg.jpg";
import { Container, Row, Col, Button, Stack } from "react-bootstrap";
import { useNavigate } from "react-router-dom/dist";
import RentNow from "../modals/RentNow";
import { useContext } from "react";
import AppContext from "../../context/AppContext";
import { useMediaQuery } from "react-responsive";
import Slider from "react-slick";
import Car from "../cards/Car";
import CategoryCard from "../cards/CategoryCard";

const BuyAccessory = ({ pickupLocation, accessories }) => {
  const { storeSeletedVehicle, isDesktopOrLaptop } = useContext(AppContext);
  const [showModal, setShowModal] = useState(false);

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 6,
    slidesToScroll: 3,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <Container
      fluid
      className="banner-image bg-fixed overlayDark"
      style={{ backgroundImage: `url(${a})`, height: "800px" }}
    >
      <Container fluid className="m-0 p-0 ">
        <h6 className="caption poppins-semiBold text-center">
          Buy From UK's Best Brand
        </h6>
        <h1 className={`txt-green text-center poppins-bold res-heading `}>
          Buy Mobile Accessories
        </h1>
        <p
          className="poppins-regular text-center res-medium-text txt-green"
          style={{
            paddingLeft: isDesktopOrLaptop ? 200 : 10,
            paddingRight: isDesktopOrLaptop ? 200 : 10,
          }}
        >
          Enhance your mobile experience with top-quality accessories. From
          screen protectors to power banks and chargers, we have everything you
          need to keep your device protected and powered up.
        </p>
        <div className="slider-container" style={{ zIndex: 999, padding: 30 }}>
          <Slider {...settings}>
            {accessories.map((item, index) => (
              <Col
                xs={12}
                lg={4}
                className="m-0 p-0 d-flex justify-content-center"
                key={index}
              >
                <CategoryCard item={item} />
              </Col>
            ))}
          </Slider>
        </div>
      </Container>
      {/* <Button
        size="sm"
        variant="outline"
        className="poppins-bold orange-outline-btn px-2 py-1"
        onClick={() => {}}
      >
        View More
      </Button> */}
    </Container>
  );
};

export default BuyAccessory;
